import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogTitle-root": {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    padding: theme.spacing(2)
  },
  "& .MuiDialogContent-root": { padding: theme.spacing(3) },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(2),
    backgroundColor: "#f5f5f5"
  }
}));

const JoinTicketModal = ({ open, onClose, ticket }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  if (!ticket) return null;

  const handleJoin = async () => {
    setLoading(true);
    try {
      await api.post(`/tickets/${ticket.id}/join`);
      onClose();
      navigate(`/tickets/${ticket.id}`);
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <StyledDialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Ticket em atendimento</DialogTitle>
      <DialogContent>
        <Typography sx={{ mt: 1 }}>
          Este ticket está sendo atendido por{" "}
          <strong>{ticket.user?.name || "outro atendente"}</strong>. Deseja
          ingressar no atendimento?
        </Typography>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ gap: 1, justifyContent: "flex-end" }}>
        <Button
          variant="contained"
          onClick={onClose}
          disabled={loading}
          sx={{
            borderRadius: 20,
            backgroundColor: "#e0e0e0",
            color: "#757575",
            minWidth: 120,
            "&:hover": { backgroundColor: "#d5d5d5" }
          }}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={handleJoin}
          disabled={loading}
          sx={{
            borderRadius: 20,
            minWidth: 120,
            backgroundColor: theme.palette.primary.main,
            "&:hover": { backgroundColor: theme.palette.primary.dark }
          }}
        >
          {loading ? "Entrando..." : "Ingressar"}
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

export default JoinTicketModal;
